(function () {
    'use strict';

    angular
        .module('pdgWp')
        .constant('MY_COLOURS', ['red', 'blue', 'grey']);

})();
